import http from "./httpVideo";

const baseUrlResource = "/buyer";

const { get, post } = http;

// export const getVideoCategory = (params: any) =>
//   get(
//     `${baseUrlResource}/goods/goods/es?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&goodsType=VIRTUAL_GOODS`
//   ); //获取默认资源临时下载地址

export const getVideoCategory = (params: any) =>
  post(`/community-api/community/video/getByPage`, params);

export const getVideoPlay = (params: any) =>
  get(`${baseUrlResource}/community/video/es?categoryId=${params}`); //获取默认资源临时下载地址

export const getVideoListMenu = (params: any) =>
  get(
    // `${baseUrlResource}/community/category/getContainsVideoNums/${params.id}`
    `/community-api/community/video/getByParentId/${params.id}`
  ); //获取默认资源临时下载地址

/**
 *  获取视频详情课程附件下载列表
 * @param params
 */
export const getVideoDownloadMenu = (params: any) => {
  return get(`/community-api/community/video/getVideoFile/${params.id}`);
};
export const getFreeDownLoad = (params: any) =>
  post(`community-api/community/developerFreeDownload/save`, params); //获取默认资源临时下载地址
